import React from 'react';
import dataNotFound from '../../assets/img/data-not-found.svg';
import {Link} from "react-router-dom";

const DataNotFound = ({message,img,button,link,btnName}) => {
    return (
        <div className='data-not-found-container d-flex align-items-center flex-column justify-content-center'>
            <img src={img?img:dataNotFound} alt="Data Not Found"/>
            <h4>{message}</h4>
            {button&&<Link className="btn btn-dark add-property-post" to={link} onClick={()=>document.getElementById('closeBtn').click()}>{btnName}</Link>  }
        </div>
    );
};

export default DataNotFound;